import React, { useEffect, useState } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import Swal from "sweetalert2";

export default function GeneratePDF() {
  const [cnic, setCnic] = useState("");
  const [mobile, setMobile] = useState("");
  const [formData, setFormData] = useState(null);
  const [students, setStudents] = useState([]);
  const [property, setProperty] = useState([]);
  const [income, setIncome] = useState([]);
  const [sibling, setSibling] = useState([]);
  const [downloadFlag, setDownloadFlag] = useState(false);

  // Candidate Image
  const image = new Image();
  // const userImageForPdf = new Image();
  // userImageForPdf.src = formData?.image;

  // 1.Academic
  const tableData1 = [
    [
      "Apply as",
      ":",
      formData?.academic?.candidate,
      "University Reg. No #",
      ":",
      formData?.academic?.roll_number,
    ],
    [
      "Year of Admission",
      ":",
      formData?.academic?.year_id,
      "University / Institute",
      ":",
      formData?.academic?.university_id,
    ],
    [
      "CGPA / Percentage",
      ":",
      formData?.academic?.percentage_id,
      "Discipline",
      ":",
      formData?.academic?.discipline_id,
    ],
  ];

  //2. Personal
  const tableData2 = [
    [
      "First Name",
      ":",
      formData?.first_name,
      "Last Name",
      ":",
      formData?.last_name,
    ],
    [
      "Father / Guardian Name",
      ":",
      formData?.father_name,
      "CNIC No. of Student",
      ":",
      formData?.cnic,
    ],
    [
      "Phone Number",
      ":",
      formData?.mobile,
      "Phone Residence",
      ":",
      formData?.landline,
    ],
    ["Email", ":", formData?.email, "Domicile", ":", formData?.domicile_id],
  ];

  // Details of Family members
  const headers = [
    "Name",
    "Age",
    "Relationship",
    "Status",
    "Occupation",
    "Organisation",
  ];

  const data = students?.map((student) => [
    student?.name,
    `${student?.age} Years`,
    student?.relation,
    student?.marital_status,
    student?.occupation,
    student?.organization,
  ]);

  // 3. Financial Details
  // Residential Property / Immovable Assets Detail

  const propertyHeaders = [
    "Property Type",
    "Exact Location",
    "Area ( in Acres / Sq Yards)",
    "Value",
  ];

  let propertyData = []; // Initialize as an empty array

  if (property.length >= 2) {
    // Make sure there are at least two properties
    propertyData = [
      [
        property[0]?.property_type || "",
        property[0]?.location || "",
        property[0]?.area || "",
        property[0]?.value || "",
      ],
      [
        property[1]?.property_type || "",
        property[1]?.location || "",
        property[1]?.area || "",
        property[1]?.value || "",
      ],
    ];
  }

  // Source of Income
  const incomeHeaders = [
    "",
    "Father's",
    "Mother's",
    "Brother's",
    "Sister's",
    "Guardian's /\nOther's",
  ];

  let incomeData = [];
  if (income.length >= 5) {
    incomeData = [
      [
        "Profession",
        income[0]?.profession,
        income[1]?.profession,
        income[2]?.profession,
        income[3]?.profession,
        income[4]?.profession,
      ],
      [
        "Salary / Pension",
        income[0]?.salary_or_pension,
        income[1]?.salary_or_pension,
        income[2]?.salary_or_pension,
        income[3]?.salary_or_pension,
        income[4]?.salary_or_pension,
      ],
      [
        "Income from all Sources",
        income[0]?.income,
        income[1]?.income,
        income[2]?.income,
        income[3]?.income,
        income[4]?.income,
      ],
    ];
  }
  // Total Income Per Annum

  const tincomeData = [
    ["Total Income\nPer Annum", formData?.total_income_per_annum],
  ];

  const siblingHeaders = ["Name", "Relationship", "University"];
  const siblingData = sibling?.map((sibling) => [
    sibling?.name,
    sibling?.relationship,
    sibling?.university,
  ]);

  // Instruction

  const tableData3 = [
    [
      "1. Copy of Student Identity Card of the University / Institute.",
      "2. Copy of Student CNIC/Copy of CNIC of Father / Guardian.",
    ],
    [
      "3. Copy of Fee Receipt of the University / Institute (Last Paid).",
      " 4. Copy of Certificate of Domicile of the student.",
    ],
    [
      "5. Copy of Permanent Residence Certificate of Student.",
      "6. Copy of Domicile Certificate of Father / Mother / Guardian.",
    ],
    [
      "7. Copy of Academic Certificates including MarkSheets of previous year.",
      "8. Copy of House documents being the evidence of Residence/Rent document.",
    ],
    [
      "9. Original Salary Slip of Father / Guardian if employed in Government / Semi Government / Private organization.",
      "10. Original Income Certificate issued by Mukhtarkar Revenue of concerned District in case Father / Guardian is a non-salary person i.e. Business man / Landlord etc., along with Bank Statement of last six (6) months of personal and Business account.",
    ],
    [
      "11. Original Copy of Income Assessment / Return of Income duly issued by Income Tax Department, Government of Pakistan.",
      "12. Copies of Utility Bills: Electricity / Gas / Telephone (Last paid).",
    ],
    [
      "13. Original Affidavit on Rs. 50/= Stamp paper.",
      "14. Incomplete applications will not be considered.",
    ],
  ];

  const handleCheckCnicAndMobile = () => {
    Swal.fire({
      title: "Verify CNIC and Mobile",
      html: `<input type="text" id="cnic" class="swal2-input" placeholder="CNIC (e.g. 12345-6789123-4)">
             <input type="text" id="mobile" class="swal2-input" placeholder="Mobile Number (e.g. 0300-1234567)"> `,
      showCancelButton: true,
      confirmButtonText: "Verify",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const cnicInput = document.getElementById("cnic");
        const mobileInput = document.getElementById("mobile");
        const cnic = cnicInput.value;
        const mobile = mobileInput.value;
        const verificationResult = await verifyCnicAndMobile(cnic, mobile);

        if (verificationResult.valid) {
          Swal.fire({
            icon: "success",
            title: "Congratulations!",
            text: "Your Scholarship form has been found!",
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "Download Scholarship Form",
          }).then((result) => {
            if (result.isConfirmed) {
              setDownloadFlag(true);
            }
          });
        } else {
          Swal.fire("Invalid CNIC or Mobile. Please try again!", "", "error");
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  const verifyCnicAndMobile = async (cnic, mobile) => {
    try {
      const response = await axios.post(
        "https://backend.form-seef.com/api/check-cnic-and-mobile",
        {
          cnic,
          mobile,
        }
      );
      const data = response.data;
      if (data && data.data) {
        setFormData(data.data);
        setStudents(data.data.members);
        setProperty(data.data.financial);
        setIncome(data.data.income);
        setSibling(data.data.sibling);
        return {
          valid: true,
          message: "CNIC and Mobile verified successfully!",
        };
      } else {
        return {
          valid: false,
          message: "Invalid CNIC or Mobile. Please try again!",
        };
      }
    } catch (error) {
      console.log("Error while verifying CNIC and Mobile:", error);
      return {
        valid: false,
        message: "Error occurred while verifying. Please try again!",
      };
    }
  };

  useEffect(() => {
    if (formData && students && property && income && sibling && downloadFlag) {
      handleDownloadPDF();
    }
  }, [formData, students, property, income, sibling, downloadFlag]);

  const handleDownloadPDF = () => {
    if (formData) {
      // Create a new PDF document
      const doc = new jsPDF("a4");

      // Format and add the data to the PDF document

      image.onload = function () {
        doc.rect(170, 50, 30, 35);
        doc.setFontSize(11);
        doc.text(
          "Please Attach\nPhoto\nPassport\nSize\n1.5in X 2in",
          185,
          60,
          null,
          null,
          "center"
        );

        // doc.addImage(userImageForPdf, "png", 170, 50, 30, 35);
        doc.addImage(this, "png", 5, 5, 18, 22);
        doc.setFontSize(13.5).setFont(undefined, "bold");
        doc.text("GOVERNMENT OF SINDH", 123, 10);
        doc.text("COLLEGE EDUCATION DEPARTMENT", 108, 16);
        doc.text("SINDH EDUCATIONAL ENDOWMENT FUND", 102, 22);
        doc.setFontSize(11.5).setFont(undefined, "bold");
        doc.text("REGISTERED VIDE TRUST DEED NO. 625/2020", 107, 28);
        doc.setFontSize(17).setFont(undefined, "bold");
        doc.text("Application for Award of Endowment Fund Scholarship", 26, 42);
        doc.setLineWidth(0.8);
        doc.line(10, 46, 200, 46);
        doc.setFontSize(14).setFont(undefined, "bold");
        doc.text("PLEASE READ ALL THE INSTRUCTIONS CAREFULLY", 10, 56);
        doc.setFontSize(10).setFont(undefined, "normal");
        doc.text(
          "1. Final Year, Over-sea or Self-Financed Students are not eligible for Financial Assistance.",
          10,
          64
        );
        doc.text(
          "2. Please Submit the Hard Copy of this Form in your university's concern department.",
          10,
          69
        );
        doc.setLineWidth(0.5);
        doc.line(10, 76, 150, 76);
        doc.setFontSize(15).setFont(undefined, "bold");
        doc.text("1. ACADEMIC INFORMATION", 10, 85);
        doc.line(10, 88, 200, 88);

        doc.autoTable({
          body: tableData1,
          startY: 92,
          columnStyles: {
            0: { fillColor: "#fff", fontSize: 11, columnWidth: 25 },
            1: { fillColor: "#fff", fontSize: 11, columnWidth: 5 },
            2: {
              fillColor: "#fff",
              fontSize: 12,
              columnWidth: 45,
              fontStyle: "bold",
            },
            3: { fillColor: "#fff", fontSize: 11, columnWidth: 25 },
            4: { fillColor: "#fff", fontSize: 11, columnWidth: 5 },
            5: {
              fillColor: "#fff",
              fontSize: 11.5,
              columnWidth: 85,
              fontStyle: "bold",
            },
          },
        });

        doc.setLineWidth(0.5);
        doc.line(10, 138, 200, 138);
        doc.setFontSize(15).setFont(undefined, "bold");
        doc.text("2. PERSONAL INFORMATION", 10, 147);
        doc.line(10, 150, 200, 150);
        doc.autoTable({
          body: tableData2,
          startY: 154,
          columnStyles: {
            0: { fillColor: "#fff", fontSize: 11, columnWidth: 25 },
            1: { fillColor: "#fff", fontSize: 11, columnWidth: 5 },
            2: {
              fillColor: "#fff",
              fontSize: 12,
              columnWidth: 60,
              fontStyle: "bold",
            },
            3: { fillColor: "#fff", fontSize: 11, columnWidth: 25 },
            4: { fillColor: "#fff", fontSize: 11, columnWidth: 5 },
            5: {
              fillColor: "#fff",
              fontSize: 12,
              columnWidth: 60,
              fontStyle: "bold",
            },
          },
        });
        // doc.line(10, 220, 200, 220);
        doc.setFontSize(13.5).setFont(undefined, "bold");
        doc.text("Details of Family Members", 10, 208);
        doc.line(10, 211, 75, 211);
        doc.autoTable({
          head: [headers],
          body: data,
          startY: 215,
          headStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
            halign: "center", // Center align header text
          },
          footStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
          },
          didParseCell: function (data) {
            data.cell.styles.fillColor = false; // remove background color
            data.cell.styles.lineWidth = 0.1; // set border width
            data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
            data.cell.styles.textColor = [0, 0, 0]; // set text color to black
          },
          didDrawPage: function (data) {
            // do something when a page is drawn
          },
        });
        doc.setLineWidth(0.5);
        doc.line(10, 283, 203, 283);
        doc.setFontSize(10).setFont(undefined, "bold");
        doc.text("Page 1 of 2", 100, 288);

        // Add a new page to the document
        doc.addPage();

        doc.setFontSize(10).setFont(undefined, "bold");
        doc.text("Page 2 of 2", 100, 10);

        doc.setLineWidth(0.5);
        doc.line(10, 13, 200, 13);
        doc.setFontSize(15).setFont(undefined, "bold");
        doc.text("3. FINANCIAL DETAILS", 10, 22);
        doc.line(10, 25, 200, 25);

        doc.setFontSize(13).setFont(undefined, "bold");
        doc.text("Residential Property / Immovable Assets Detail", 10, 31);
        doc.line(10, 33, 120, 33);

        doc.autoTable({
          head: [propertyHeaders],
          body: propertyData,
          startY: 36,
          headStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
            halign: "center", // Center align header text
          },
          footStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
          },
          didParseCell: function (data) {
            data.cell.styles.fillColor = false; // remove background color
            data.cell.styles.lineWidth = 0.1; // set border width
            data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
            data.cell.styles.textColor = [0, 0, 0]; // set text color to black
          },
        });
        doc.setFontSize(13).setFont(undefined, "bold");
        doc.text(
          "Source of Income (Provide DOCUMENTARY EVIDENCE for Income)",
          10,
          70
        );
        doc.line(10, 73, 170, 73);

        doc.autoTable({
          head: [incomeHeaders],
          body: incomeData,
          startY: 76,
          headStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
            halign: "center", // Center align header text
          },
          footStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
          },
          didParseCell: function (data) {
            data.cell.styles.fillColor = false; // remove background color
            data.cell.styles.lineWidth = 0.1; // set border width
            data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
            data.cell.styles.textColor = [0, 0, 0]; // set text color to black
          },
        });
        doc.autoTable({
          body: tincomeData,
          startY: 124,

          footStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
          },
          didParseCell: function (data) {
            data.cell.styles.fillColor = false; // remove background color
            data.cell.styles.lineWidth = 0.1; // set border width
            data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
            data.cell.styles.textColor = [0, 0, 0]; // set text color to black
          },
        });
        doc.setFontSize(13).setFont(undefined, "bold");
        doc.text("Details Sibling Already Availing SEEF Scholarship", 10, 142);
        doc.line(10, 144, 120, 144);
        doc.autoTable({
          head: [siblingHeaders],
          body: siblingData,
          startY: 146,
          headStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
            halign: "center", // Center align header text
          },
          footStyles: {
            textColor: [0, 0, 0], // set text color to black
            fillColor: false, // remove background color
          },
          didParseCell: function (data) {
            data.cell.styles.fillColor = false; // remove background color
            data.cell.styles.lineWidth = 0.1; // set border width
            data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
            data.cell.styles.textColor = [0, 0, 0]; // set text color to black
          },
        });
        doc.line(10, 163, 200, 163);
        doc.setFontSize(14).setFont(undefined, "bold");
        doc.text("4. Required Documents", 10, 170);
        doc.line(10, 173, 200, 173);
        doc.autoTable({
          body: tableData3,
          startY: 176,
          columnStyles: {
            0: {
              fillColor: "",
              fontSize: 10.5,
              columnWidth: 85,
              cellPadding: { left: 1 },
            },
            1: {
              fillColor: "",
              fontSize: 10.5,
              columnWidth: 100,
              cellPadding: { left: 7 },
            },
          },
          didParseCell: function (data) {
            //         //     // Check if it's the first cell

            // Draw the checkbox
            const checkboxSize = 3;
            doc.setLineWidth(0.1);
            doc.rect(10, 176.5, checkboxSize, checkboxSize, "S");
            doc.rect(100, 176.5, checkboxSize, checkboxSize, "S");
            doc.rect(10, 184, checkboxSize, checkboxSize, "S");
            doc.rect(100, 184, checkboxSize, checkboxSize, "S");
            doc.rect(10, 193, checkboxSize, checkboxSize, "S");
            doc.rect(100, 193, checkboxSize, checkboxSize, "S");
            doc.rect(10, 201, checkboxSize, checkboxSize, "S");
            doc.rect(100, 201, checkboxSize, checkboxSize, "S");
            doc.rect(10, 210, checkboxSize, checkboxSize, "S");
            doc.rect(100, 210, checkboxSize, checkboxSize, "S");
            doc.rect(10, 232, checkboxSize, checkboxSize, "S");
            doc.rect(100, 232, checkboxSize, checkboxSize, "S");
            doc.rect(10, 244.5, checkboxSize, checkboxSize, "S");
            doc.rect(100, 244.5, checkboxSize, checkboxSize, "S");
          },
        });
        doc.line(10, 251, 200, 251);
        doc.setFontSize(14).setFont(undefined, "bold");
        doc.text("5. AFFIDAVIT", 10, 257);
        doc.line(10, 260, 200, 260);
        doc.setFontSize(13);
        doc.text(
          "Submit the Affidavit, duly printed on Stamp paper of value Rs. 50/, alongwith this form.",
          10,
          265
        );

        doc.setLineWidth(0.5);
        doc.line(195, 276, 145, 276);
        doc.setFontSize(10).setFont(undefined, "bold");
        doc.text("Signature of the Student", 150, 280);

        doc.setLineWidth(0.5);
        doc.line(82, 276, 15, 276);
        doc.setFontSize(10).setFont(undefined, "bold");
        doc.text("Signature of the Parents/Guardian", 20, 280);

        // ... (Add your PDF content generation code here using the formData)

        // Save the PDF
        doc.save("SEEF Scholarship Form.pdf");

        setDownloadFlag(false);
        setFormData(null);
        setStudents([]);
        setProperty([]);
        setIncome([]);
        setSibling([]);
      };
    }
    image.src = "/logo.png";
  };

  return (
    <div>
      <form>
        <button type="button" onClick={handleCheckCnicAndMobile}>
          DOWNLOAD SCHOLARSHIP FORM
        </button>
      </form>
    </div>
  );
}
